import React, { useState, useContext, useEffect } from "react";
import { ThemeContext } from "styled-components";
import { useTranslation } from "react-i18next";
import { api, keySession, keyUserAccess } from "../../services/axios";
import Toast from "../../components/Toast";
import { encrypt } from "../../utils/crypto";
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import acesso from "../../assets/acesso.png";
import iemail from "../../assets/email.png";
import aemail from "../../assets/emailA.png";
import qrcode from "../../assets/qr-code.png";
import qrcodeb from "../../assets/qr-codeb.png";
import logo from "../../assets/logoTrans.png";

import { Titulo, Linha, EyeOpen, EyeClose, CardOption, CardImg, LinkBtn, LoginBtn } from './styles';
import { getDevice } from "../../utils/helpers";

export default function Login() {
  const { t } = useTranslation();
  const { colors } = useContext(ThemeContext);
  const [showLogin, setShowLogin] = useState(0);
  const [user, setUser] = useState("");
  const [passWord, setPassWord] = useState("");
  const [showPassWord, setShowPassWord] = useState(true);
  const [msgModal, setMsgModal] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedValue, setSelectedValue] = React.useState("0");
  const [device, setDevice] = useState(false)

  const styleInput = {
    background: 'transparent',
    width: '90%',
    borderBottom: `1px solid ${colors.c02} !important`,
    borderTop: `1px solid ${colors.c02} !important`,
    borderLeft: `1px solid ${colors.c02} !important`,
    borderRight: `1px solid ${colors.c02} !important`,
    borderRadius: '10px',
    border: 0,
    outline: 0,
    caretColor: colors.c02,
    margin: '10px',
    input: {
      color: colors.c06,
    },
    "input:-webkit-autofill, input:-webkit-autofill:focus": {
      transition: 'background-color 600000s 0s, color 600000s 0s'
    },
    label: {
      color: colors.c04,
      fontWeight: 'bold'
    },
    divHeig: {
      border: 0,
      padding: 0,
      outline: 0,
      margin: 0,
      width: '100%'
    },
    fieldset: {
      border: 0
    },
    "& label.Mui-focused": {
      background: 'transparent',
      color: colors.c04
    },
    "& .MuiInput-underline:after": {
      background: 'transparent',
      borderBottomColor: colors.c04
    },
    "& .MuiOutlinedInput-root": {
      background: 'transparent',
      "&.MuiInputBase-root": {
        color: colors.c04
      },
      "& fieldset": {
        borderColor: colors.c04
      },
      "&:hover fieldset": {
        borderColor: colors.c04
      },
      "&.Mui-focused fieldset": {
        borderColor: colors.c04
      }
    }
  };

  useEffect(() => {
    setDevice(getDevice());
  }, [])

  async function onSendLogin() {
    try {
      setMsgModal(t("login.waitLogin").toString());
      handleOpen();
      var passw = '';
      if (passWord) passw = await encrypt(passWord)
      const response = await api.post("/login", { user: user, password: passw });
      if (response.status === 200) {
        const { result } = response.data;
        var session = {
          token: result.token,
          email: result.userEmail,
          name: result.userName
        };
        localStorage.setItem(keySession, JSON.stringify(session));
        handleClose();
        if (!device) {
          window.location.replace("/home");
        }
        handleClose();
      } else {
        handleClose();
        Toast({ type: "warn", message:response.data.message });
      }
    } catch (error) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  }

  useEffect(() => {
    localStorage.removeItem(keySession)
    localStorage.removeItem(keyUserAccess)
  }, [])

  return (
    <Grid container spacing={0} direction="column" alignItems="center" sx={{ minHeight: '100vh', background: colors.c02 }}>
        <Grid item xs={1} sx={{ width: '380px' }}>
          <Paper sx={{ borderRadius: '10px', padding: '10px', marginTop: '40px', backgroundColor: colors.c01 }}>
              <div style={styleInput.divHeig}>
                <Titulo>Login</Titulo>
                <TextField
                  sx={styleInput}
                  placeholder= "Usuário *" 
                  type="text"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                />
                <TextField
                  sx={styleInput}
                  placeholder= "Password *" 
                  type={showPassWord ? "password" : "text"}
                  value={passWord}
                  onChange={(e) => setPassWord(e.target.value)}
                  InputProps={{
                    endAdornment: showPassWord ? (
                      <EyeClose onClick={() => setShowPassWord(false)} size={25} />
                    ) : (
                      <EyeOpen onClick={() => setShowPassWord(!showPassWord)} size={25} />
                    ),
                  }}
                />
                <Grid container>
                  <LoginBtn type="button" onClick={() => onSendLogin()}>
                    Entrar
                  </LoginBtn>
                </Grid>
              </div>
          </Paper>
          <Box sx={{ textAlign: 'center', alignContent: 'center' }}>
            <Backdrop
              sx={(theme) => ({ color: colors.c04, zIndex: theme.zIndex.drawer + 1 })}
              open={open}
              onClick={handleClose}
            >
              <CircularProgress color="inherit" />
              <Box px={1} />
              {msgModal}
            </Backdrop>
          </Box>
        </Grid>
    </Grid>
  );
}